// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import styled from "styled-components"
import { FontStyle } from "../../data/types"
import { getStylesForFontStyle } from "../helpers/style-helpers"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"
import { useSizing } from "../helpers/use-sizing"

const StyledRoot = styled("span")<{ fontStyle: FontStyle }>`
  ${(props) => getStylesForFontStyle(props.fontStyle)}
`

interface Props
  extends React.HTMLAttributes<HTMLSpanElement>,
    PrimitiveBaseProps<HTMLSpanElement>,
    PrimitiveWithSizing {
  children: string
  fontStyle: FontStyle
}

export function Text(props: Props) {
  const {
    className,
    innerRef,
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    fontStyle,
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)

  return (
    <StyledRoot
      {...otherProps}
      className={classNames(resetStyles.reset, className, sizingClassName)}
      ref={innerRef}
      data-node-id={dataNodeId}
      fontStyle={fontStyle}
    />
  )
}
